<template>

    <div :class="'form-group ' + groupClass">
        <slot name="prev"></slot>

        <label v-if="label" :for="id" v-html="label" :class="labelClass"></label>

        <slot name="inputGroup">
            <div class="input-group">

                <div class="input-group-prepend" @click="onIconLeftClick">
                    <template v-if="iconLeft">
                    <span class="form-control">
                        <i :class="iconLeft" aria-hidden="true"></i>
                    </span>
                    </template>
                    <template v-if="iconSide === 'prepend' && !!icon">
                    <span class="form-control h-100">
                        <i :class="icon" aria-hidden="true"></i>
                    </span>
                    </template>
                </div>

                <div
                        :class="['position-relative form-control d-flex flex-wrap h-auto p-0', {'border-left-0': iconLeft || (iconSide === 'prepend' && icon)}, {'is-invalid': !!error}]"
                >
                    <slot name="beforeInput"></slot>
                    <div :class="['position-relative d-flex flex-grow-1 w-100', inputContainerClass]">
                        <div class="w-100 overflow-hidden">
                            <slot
                                    name="input"
                                    v-bind="{ ...$props }"
                            >
                                <input
                                        :type="type"
                                        :name="name || false"
                                        :id="id"
                                        :class="['form-control d-flex flex-grow-1 w-100 border-0 py-0', inputClass, inputSpaceX]"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        :placeholder="placeholder"
                                        :required="required"
                                        :readonly="readonly"
                                        :disabled="disabled"
                                        @click="onClick"
                                        @focus="onFocus"
                                        @blur="onBlur"
                                        @keyup="onKeyUp"
                                        @keydown="onKeyDown"
                                        @keyPress="onKeyPress"
                                        v-on:input="$emit('input', $event.target.value)"
                                        :value="value"
                                        v-model="inputValue"
                                        ref="input"
                                >
                            </slot>
                        </div>
                        <slot name="inputContainer"></slot>
                    </div>
                    <slot name="afterInput"></slot>
                </div>

                <div class="input-group-append" @click="onIconRightClick">
                    <template v-if="iconSide === 'append' && !!icon">
                    <span class="form-control">
                        <i :class="icon" aria-hidden="true"></i>
                    </span>
                    </template>
                    <template v-if="iconRight">
                    <span class="form-control">
                        <i :class="iconRight" aria-hidden="true"></i>
                    </span>
                    </template>
                </div>

            </div>
        </slot>

        <template v-if="error">
            <span class="pl-3" :class="{'invalid-feedback': true, 'show': !!error}" role="alert">
                <span>
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </span>
                <span v-html="error"></span>
            </span>
        </template>

        <div style="display:none">
            <slot name="hidden">
            </slot>
        </div>

        <slot name="next"></slot>
    </div>

</template>

<script>
    import mixinInput from './mixinInput';
    import { uniqueId } from 'lodash';

    export default {
        mixins: [ mixinInput ],
        props: {
            label: {
                type: String,
                default: ''
            },
            labelClass: {
                type: String,
                default: ''
            },
            iconSide: {
                type: String,
                default: 'append'
            },
            icon: {
                type: String,
                default: ''
            },
            iconLeft: {
                type: String,
                default: ''
            },
            iconRight: {
                type: String,
                default: ''
            },

            onIconLeftClick: {
                type: Function,
                default: () => {}
            },
            onIconRightClick: {
                type: Function,
                default: () => {}
            },

            iconText: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            name: {
                type: String,
                default: ''
            },
            groupClass: {
                type: String,
                default: ''
            },
            inputContainerClass: {
                type: String,
                default: ''
            },
            inputClass: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: uniqueId('elm_')
            },
            placeholder: {
                type: String,
                default: ''
            },
            /*value: {
                type: String,
                default: ''
            },*/
            readonly: null,
            disabled: null,

            required: null,

            onClick: {
                type: Function,
                default: () => {}
            },
            onFocus: {
                type: Function,
                default: () => {}
            },
            onBlur: {
                type: Function,
                default: () => {  }
            },
            onKeyDown: {
                type: Function,
                default: () => {}
            },
            onKeyUp: {
                type: Function,
                default: () => {}
            },
            onKeyPress: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                //inputValue: this.value
                inputSpaceX: 'pl-4 pr-5'
            };
        },
        watch: {
            /*value: {
                handler( value ) {
                    if( value !== this.inputValue ) {
                        this.inputValue = value;
                    }
                }
            },*/
            iconRight: {
                handler( inputValue ) {
                    this.checkSpace();
                }
            },
            icon: {
                handler( inputValue ) {
                    this.checkSpace();
                }
            }
        },
        mounted() {
            this.checkSpace();
        },
        methods: {
            reset() {
                this.inputValue = this.value+'';
            },
            checkIsValid() {
                return !this.error;
            },
            checkSpace()
            {
                if(
                    (this.iconRight != '' && this.iconLeft == '') ||
                    (this.icon != '' && this.iconSide == 'append')
                ){
                    this.inputSpaceX = 'pl-2 pr-5';
                }else if(
                    (this.iconLeft != '' && this.iconRight == '') ||
                    (this.icon != '' && this.iconSide == 'prepend') ){
                    this.inputSpaceX = 'pl-5 pr-2';
                }else if(this.iconLeft != '' && this.iconRight != ''){
                    this.inputSpaceX = 'px-5';
                }else{
                    this.inputSpaceX = 'px-2';
                }
            }
        }
    }
</script>
